import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { createScheduleDetails, updateScheduleDetails } from 'src/app/store/actions/schedule.action';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-create-schedule-details-confirm',
  templateUrl: './create-schedule-details-confirm.component.html',
  styleUrls: ['./create-schedule-details-confirm.component.scss']
})
export class CreateScheduleDetailsConfirmComponent implements OnInit {

  data!: any;
  type!: any;
  
  constructor(
    private store: Store<AppState>,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

  submit(){
    console.log(this.data);
    this.store.dispatch(setLoadingSpinner({status: true}));
    if(this.type == 'create'){
      this.store.dispatch(createScheduleDetails({data: this.data}));
    } else{
      this.store.dispatch(updateScheduleDetails({data: this.data}));
    }
  }

  dismiss(){
    this.modalService.hideCreateScheduleDetailsConfirm();
  }

}
